import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { formValueSelector } from "redux-form";
import { push } from "react-router-redux";
import Form from "../../components/forms/OfficialFormAdding";
import {
  saveOfficial,
  deleteOfficial,
  withRedirect,
  getOfficialAddress,
  unarchiveOfficial,
  getForwardingPayload,
  markOfficialsAsInspected,
} from "../../CroActions";
import { buildDocx } from "../../../../utils/htmlToDocx";
import { isLegitimate, isInternal, isOvm } from "../../CroUtils";
import { breadcrumbs } from "../../../../actions/appActions";
import { convert, addressToForm } from "../../converts";
import { map } from "lodash";

const postProcess = (data) =>
  convert(data, {
    birthAddress: addressToForm,
    deliveryAddress: addressToForm,
    permanentAddress: addressToForm,
  });
const selector = formValueSelector("officialForm");

const mapStateToProps = (state, { params, auth }) => ({
  loginData: selector(state, "firstName", "lastName", "id"),
  workingPositions: selector(state, "workingPositions") || [],
  statements: selector(state, "statements") || [],
  breadcrumbsItems: isLegitimate(auth)
    ? [{ label: "Funkcionář" }]
    : [{ label: "Funkcionář" }, { label: "Detail funkcionáře" }],
  url: `${auth.startUrl}/api/funkcionari/${params.id}`,
  disabled: isLegitimate(auth),
  canListStatements: isLegitimate(auth) || isInternal(auth),
  postProcess,
  ovmIds: map(selector(state, "ovms") || [], (ovm) => ovm.id),
  judge: selector(state, "judge") || null,
  isMy: selector(state, "isMy"),
  checkedISZR: selector(state, "checkedISZR"),
  checked: selector(state, "checked"),
  deputyOrSenator: selector(state, "deputyOrSenator"),
  username: selector(state, "username"),
  password: selector(state, "plainPassword"),
  isEdited: true,
  isArchived: selector(state, "archived"),
  aifo: selector(state, "aifo"),
  permanentAddress: selector(state, "permanentAddress"),
  permanentAddressUpdateDate: selector(state, "permanentAddressUpdateDate"),
  deathDate: selector(state, "deathDate"),
  canGeneratePassword: selector(state, "canGeneratePassword"),
  canDisplayCredentials: selector(state, "canDisplayCredentials"),
});

const onSubmitWithoutRedirect = (url) => saveOfficial(url);
const onSubmit = (auth) => withRedirect(saveOfficial(auth.startUrl), `${auth.startUrl}/funkcionari`);
const onDelete = (url) =>
  withRedirect(deleteOfficial(url), `${url}/funkcionari`);
const onUnarchive = (url) =>
  withRedirect(unarchiveOfficial(url), `${url}/archivace/funkcionari`);

const onChecked = (url, id) => () => markOfficialsAsInspected(url, [id]);

const mapDispatchToProps = (dispatch, { params, auth }) => ({
  ...bindActionCreators(
    {
      onSubmit: onSubmit(auth),
      onSubmitWithoutRedirect: onSubmitWithoutRedirect(auth.startUrl),
      onUnarchive: onUnarchive(auth.startUrl),
      onChecked: onChecked(auth.startUrl, params.id),
      breadcrumbs,
    },
    dispatch,
  ),

  onDelete: () => dispatch(onDelete(auth.startUrl)(params.id)),
  onAppeal: (noticeTypeId) =>
    dispatch(push({ pathname: `${auth.startUrl}/funkcionari/${params.id}/vyzva`, state: { noticeTypeId } })),
  onShowHistory: (params.id && isInternal(auth))
    ? () => dispatch(push(`${auth.startUrl}/funkcionari/${params.id}/historie`))
    : null,
  getAddress: () => getOfficialAddress(auth.startUrl, params.id, dispatch),
  onForwardOfficial: async ({ reason, workingPositionId, administrativeAuthorityId }) => {
    const payload = await getForwardingPayload(auth.startUrl, params.id, {
      reasonId: reason?.id,
      workingPositionId,
      administrativeAuthorityId,
    }, dispatch);
    await buildDocx(payload);
  },
  dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(Form);
